import { apiDelete, apiGet, apiPatch, apiPost } from './apiClient.js';

export const automationApi = {
  listTriggers:  ()        => apiGet('/api/automation/triggers'),
  listRules:     (params)  => apiGet('/api/automation/rules', params),
  createRule:    (body)    => apiPost('/api/automation/rules', body),
  setRuleEnabled:(id, enabled) => apiPatch(`/api/automation/rules/${id}/enabled`, { enabled }),
  deleteRule:    (id)      => apiDelete(`/api/automation/rules/${id}`),

  listRuns:      (params)  => apiGet('/api/automation/runs', params),
  markRunRead:   (id)      => apiPatch(`/api/automation/runs/${id}/read`),
  markAllRunsRead: ()      => apiPost('/api/automation/runs/read-all', {}),
};
